import { Modal, Form, Input, Switch } from "antd";

interface Props {
  open: boolean;
  onCancel: () => void;
  onSave: (values: any) => void;
}

export default function TipoDocumentoModal({ open, onCancel, onSave }: Props) {
  const [form] = Form.useForm();

  const handleOk = () => {
    form.validateFields().then(values => {
      onSave(values);
      form.resetFields();
    });
  };

  return (
    <Modal
      title="Novo Tipo de Documento"
      open={open}
      onOk={handleOk}
      onCancel={() => {
        form.resetFields();
        onCancel();
      }}
      okText="Salvar"
      cancelText="Cancelar"
    >
      <Form layout="vertical" form={form}>
        <Form.Item name="nmTpDoc" label="Nome" rules={[{ required: true }]}>
          <Input />
        </Form.Item>

        <Form.Item name="temDataEmissao" valuePropName="checked">
          <Switch /> Tem Data de Emissão
        </Form.Item>

        <Form.Item name="temDataVencimento" valuePropName="checked">
          <Switch /> Tem Data de Vencimento
        </Form.Item>

        <Form.Item name="temNumero" valuePropName="checked">
          <Switch /> Tem Número
        </Form.Item>

        <Form.Item name="temEmissor" valuePropName="checked">
          <Switch /> Tem Emissor
        </Form.Item>

        <Form.Item name="temUf" valuePropName="checked">
          <Switch /> Tem UF
        </Form.Item>

        <Form.Item name="temPais" valuePropName="checked">
          <Switch /> Tem País
        </Form.Item>

        <Form.Item name="temNome" valuePropName="checked">
          <Switch /> Tem Nome
        </Form.Item>
      </Form>
    </Modal>
  );
}
